import React from 'react';
import {Row, Col} from 'react-bootstrap';

import embodeeBuilderBaseUrl from "../../api/config/embodeeBuilderBaseUrl";
import {NtsImage} from "../ntsImage/NtsImage";
import {getEmbodeeFillInImage} from "../../helpers/embodeeHelpers";
import {IMAGE_UNAVAILABLE_URL} from "../../helpers/constants";
import {getProductImageUrl} from "../nikeMediaPlatform/imageHelpers";

/**
 * Displays list of invalid fill-in cart products. Supports JBA, Custom Stock and Blank Stock products.
 *
 * @usage:
 * <FillInErrorPanel products={[ { design:{}, productDetails:{}, error:'' } ]} isJba={true|false} />
 *
 * @props
 * errors - Array of objects with imgSrc, errMsg
 *
 */
export class FillInErrorPanel extends React.Component {

  getImageSrc = (product) => {
    if (product.design) { //is custom stock product
      //TODO: User checkoutHelpers.getSapCustomStockImageUrl(uniformDetails, product)?
      return product.design.templates['Front'].imageUrl ? product.design.templates['Front'].imageUrl : product.design.templates['Back'].imageUrl;
    } else { //is stock product
      try {
        const styleColor = `${product.selectedStyle.styleNumber}-${product.selectedStyle.colorNumber}`;
        return getProductImageUrl(`${styleColor}-Front`, 160, 240);
      } catch(e) {
        return IMAGE_UNAVAILABLE_URL;
      }
    }
  };

  getProductName = (product) => {
    try {
      if(this.props.isJba){
        return product.name;
      } else {
        return product.selectedStyle.details.displayName;
      }
    } catch(e) {
      return 'Name Not Available';
    }
  };

  getProductUid = (product) => {
    if (this.props.isJba) { //is jba product
      return product.designId || 'Uniform ID Not Available';
    } else if (product.design) { //is custom stock product
      return product.design.id || 'Design ID Not Available';
    } else {
      try {
        return `${product.selectedStyle.styleNumber}-${product.selectedStyle.colorNumber}`;
      } catch(e) {
        return 'Style-Color Not Available';
      }
    }
  };

  render() {

    if (Array.isArray(this.props.products) && this.props.products.length) {

      const productsWithErrors = this.props.products.filter((product) => {
        return (product.error)
      });

      if (Array.isArray(productsWithErrors) && productsWithErrors.length) {

        const jbaClass = this.props.isJba ? 'is-jba' : '';

        return (

          <div className="nts-cart-fillin-error-panel">
            <Row>
              <Col xs={12}>
                <div className="nts-cart-fillin-error-title">
                  <h4>FILL-IN ERROR</h4>
                </div>
              </Col>
            </Row>

            {productsWithErrors.map((product, i) => (
              <Row className={`nts-cart-fillin-error-product-container ${jbaClass}`} key={i}>
                <Col xs={12}>
                   <div className="nts-cart-fillin-product-image">
                     <span className={`nsg-glyph--alert ${jbaClass}`}></span>
                     {this.props.isJba ?
                         <>
                           <NtsImage className={`${jbaClass}`} src={getEmbodeeFillInImage(product.designId, 'top')} alt="Product ineligible for fill-in" />
                           <NtsImage className={`${jbaClass}`} src={getEmbodeeFillInImage(product.designId, 'bottom')} alt="Product ineligible for fill-in" />
                         </> :
                         <img src={this.getImageSrc(product)} alt="Product ineligible for fill-in" />
                     }

                   </div>
                   <div className={`nts-cart-fillin-product-content ${jbaClass}`}>
                     <div className="nts-cart-filling-product-details">
                       <p className="nts-cart-fillin-product-name">{this.getProductName(product)}</p>
                       <p className="nts-cart-fillin-product-id">{this.getProductUid(product)}</p>
                       <div className="nts-cart-fillin-error-msg">{product.error}</div>
                     </div>
                   </div>
                </Col>
              </Row>
            ))}

          </div>
        );
      } else {
        // No errors to display for fill-in cart
        return null;
      }
    }
  }
}
